module.exports = __webpack_public_path__ + "static/img/2.db45224.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mentmo/3/2.png
// module id = pf3Q
// module chunks = 0